import { render, staticRenderFns } from "./StrategyBag.vue?vue&type=template&id=3b79a6a9&"
import script from "./StrategyBag.vue?vue&type=script&lang=js&"
export * from "./StrategyBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports